import isNull from 'lodash/isNull';

export const formatMoney = (value, keepDecimals = false) => {
	value = !isNull(value) ? value.toString() : '';

	// Remove all chars except numbers and .
	value = value.replace(/[^0-9.-]/g, '');

	// Create an array with sections split by .
	const sections = value.split('.');
	let res;

	// Remove any leading 0s apart from single 0
	if (sections[0] !== '0' && sections[0] !== '00') {
		sections[0] = sections[0].replace(/^0+/, '');
	} else {
		sections[0] = '0';
	}

	// If numbers exist after first .
	if (sections[1] && !!keepDecimals) {
		// Join first two sections and truncate end section to length 2 only if decimals are not .00
		res = sections[1].slice(0, 2) === '00' ? sections[0] : sections[0] + '.' + sections[1].slice(0, 2);
		// If original value had a decimal place at the end, add it back
	} else if (value.indexOf('.') !== -1 && !!keepDecimals) {
		res = sections[0] + '.';
		// Otherwise, return only section
	} else {
		res = sections[0];
	}

	return res.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
};

export function formatEnumFormOptions(enumArray) {
	return enumArray.map(enumObject => {
		return {
			value: enumObject.id,
			label: enumObject.text.replace(enumObject.text[0], s => s.toUpperCase())
		};
	});
}



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/format.js